<a {href}
   id="settings-list-button-{href}"
   on:click="fire('click', event)"
   rel="prefetch"
   aria-label={ariaLabel || label}
   class="settings-list-button focus-fix {className ? className : ''}"
>
  <span>
    {label}
  </span>
</a>
<style>
  .settings-list-button {
    display: flex;
    flex-grow: 1;
  }
  .settings-list-button span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<script>
  export default {
    data: () => ({
      ariaLabel: undefined,
      className: undefined
    })
  }
</script>
